/*
This file is located in the main branch
Last time the file was updated (UTC): [02.07.2024 18:52:57]
Permissions to update outside the main branch: [false]
*/

import { DropDown } from '@finbeat/react-toolkit';
import { AxiosInstance } from 'axios';
import ResTable from 'models/api/table';
import {
    TariffGroup,
    TariffGroupChange,
    TariffGroupCreate,
    TariffGroupFilter,
    TariffGroupTable,
} from 'models/api/tariffGroup';
import { CreditProduct } from '../models/api/creditProduct';

export const getTariffGroups = async (axios: AxiosInstance, params: TariffGroupFilter) => {
    const { data } = await axios.get<ResTable<TariffGroupTable>>(`/TariffGroups`, {
        params,
    });
    return data;
};

export const getTariffGroupsSelect = async (axios: AxiosInstance) => {
    const { data } = await axios.get<DropDown[]>(`/TariffGroups/select-list`);
    return data;
};

export const getTariffGroupItem = async (axios: AxiosInstance, id: number) => {
    const { data } = await axios.get<undefined, { data: TariffGroup }>(`/TariffGroups/${id}/`);
    return data;
};

export const getTariffGroupExcel = async (axios: AxiosInstance, params: TariffGroupFilter) => {
    const { data } = await axios.get<Blob>('/TariffGroups/excel', {
        responseType: 'arraybuffer',
        params: { ...params },
    });
    return data;
};

export const createTariffGroupItem = async (axios: AxiosInstance, item: TariffGroupCreate) =>
    await axios.post<TariffGroup>('/TariffGroups', item);

export const changeTariffGroupItem = async (axios: AxiosInstance, item: TariffGroupChange) => {
    return await axios.post(`/TariffGroups/${item.id}`, item);
};

export const deleteTariffGroupItem = async (axios: AxiosInstance, id: number) => {
    return await axios.delete(`/TariffGroups/${id}`);
};

export const getCreditProductsList = async (axios: AxiosInstance, onlyActive = false) => {
    const { data } = await axios.get<CreditProduct[]>(`/TariffGroups/creditProducts`, {
        params: {
            onlyActive,
        },
    });
    return data;
};
